// extracted by mini-css-extract-plugin
module.exports = {"areaTitle":"portfolio-module--area-title--1Otca"};